import { render, staticRenderFns } from "./responsible.vue?vue&type=template&id=568d8fe3&"
import script from "./responsible.vue?vue&type=script&lang=js&"
export * from "./responsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports